// extracted by mini-css-extract-plugin
export var cardHeader = "_tl-0";
export var reorderHandle = "_tl-3";
export var titleArea = "_tl-1";
export var titleAreaWithHandle = "_tl-2";